import { AnswerMatchType } from './answer-match-type.enum';
import { QuestionOption } from './question-option';
import { QuestionType } from './question-type.enum';
import { RichText } from './rich-text';

export class QuestionContent {
  analysis: RichText;
  answer: string;
  answerMatchType: AnswerMatchType;
  id: number;
  idx: number;
  options: QuestionOption[] = [];
  qusStem: RichText;
  type: QuestionType;
  // å¡«ç©ºé¢ä¸ç¨
  blankNum?: number;
  score: number;
  needRemoved: boolean = false;


  constructor(type = QuestionType.SINGLE_SELECT) {
    this.type = type;
    this.analysis = new RichText();
    this.answer = '';
    this.answerMatchType = AnswerMatchType.EXACTLY_IN_ANY_ORDER;
    this.qusStem = new RichText();

    switch (type) {
      case QuestionType.SINGLE_SELECT:
      case QuestionType.MULTI_SELECT:
      case QuestionType.UNCERTAIN_SELECT:
        this.options = [
          new QuestionOption(),
          new QuestionOption(),
          new QuestionOption(),
          new QuestionOption()
        ];
        break;
      case QuestionType.TRUE_OR_FALSE:
        this.options = [
          new QuestionOption(),
          new QuestionOption(),
        ];
        break;
      case QuestionType.FILL_BLANK:
        this.blankNum = 1;
        this.options = [new QuestionOption()];
        break;
      case QuestionType.SHORT_ANSWER:
        this.options = [];
        break;
    }
  }
}
